import { render, staticRenderFns } from "./productPublish.vue?vue&type=template&id=ab19f5e2&scoped=true"
import script from "./productPublish.vue?vue&type=script&lang=js"
export * from "./productPublish.vue?vue&type=script&lang=js"
import style0 from "./productPublish.vue?vue&type=style&index=0&id=ab19f5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab19f5e2",
  null
  
)

export default component.exports